// import BaseService from '@/utils/BaseService';
import { service as request } from "@/api/http";
import { isRuleStatisticRequest, withRuleStatisticTenant } from "./ruleStatisticTenant";
// import SystemConst from '@/utils/const';

class Service {
  // api request
  public requestCommon = (url: string, params: any) =>
    isRuleStatisticRequest(url, params)
      ? withRuleStatisticTenant(params).then((config) => request(url, config))
      : request(`${url}`, params);

  public requestCommonModel = ({ url = "", params = {} }) =>
    request(`${url}`, params);

  public initMenu = () =>
    request('/api/card/getCardByUserId');
}

export default Service;
